import { FC } from "react";
import { useTranslation } from "react-i18next";
import LogoSVG from "../../resources/svg/LogoSVG";

const OrganisatorsSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-[#F1F1F1]">
            <div className="relative flex justify-center items-center py-[110px] dmax2:py-[60px] mx-auto dmin2:w-[1280px] di8:w-[1138px] di7:w-[960px] ti3:w-[860px] td8:w-[767px] ti7:w-[600px] ti8:w-[500px] mi2:w-[440px] mi1:w-[360px] mi5:w-[320px]">
                <div className="relative flex flex-col justify-start items-start w-full">
                    <div className="flex justify-center items-center mb-[50px] dmax2:mb-9">
                        <h2 className="H24B mr-5">{t("organisatorsSection.title").toUpperCase()}</h2>
                        <LogoSVG />
                    </div>
                    <div className="flex dmax5:flex-col">
                        <div className="relative flex flex-col items-center w-[50%] dmax5:w-full dmin5:mr-[30px] dmax5:mb-[30px]">
                            <div className="w-full mb-[30px]">
                                <p className="H16 text-[#848484] mb-3">{t("organisatorsSection.text1")}</p>
                                <p className="H16 text-[#848484] mb-3">{t("organisatorsSection.text2")}</p>
                                <p className="H16 text-[#848484] mb-3">{t("organisatorsSection.text3")}</p>
                                <p className="H16 text-[#848484] mb-3">{t("organisatorsSection.text4")}</p>
                                <p className="H16 text-[#848484] mb-3">{t("organisatorsSection.text5")}</p>
                                <p className="H16 text-[#848484]">{t("organisatorsSection.text6")}</p>
                            </div>
                            <div className="flex justify-between w-full max-w-[585px]">
                                <div className="flex flex-col items-center">
                                    <span className="H32B dmax6:H24B mb-[6px]">
                                        {t("organisatorsSection.indicator1")}
                                    </span>
                                    <span className="H16 dmax6:H14 text-center text-[#848484]">
                                        {t("organisatorsSection.indicatorName1")}
                                    </span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <span className="H32B dmax6:H24B mb-[6px]">
                                        {t("organisatorsSection.indicator2")}
                                    </span>
                                    <span className="H16 dmax6:H14 text-center text-[#848484]">
                                        {t("organisatorsSection.indicatorName2")}
                                    </span>
                                </div>
                                <div className="flex flex-col items-center">
                                    <span className="H32B dmax6:H24B mb-[6px]">
                                        {t("organisatorsSection.indicator3")}
                                    </span>
                                    <span className="H16 dmax6:H14 text-center text-[#848484]">
                                        {t("organisatorsSection.indicatorName3")}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="w-[50%] dmax5:w-full h-[476px] ti3:h-[420px] td8:h-[390px] ti7:h-[420px] ti8:h-[360px] mi2:h-[360px] mi1:h-[360px] mi5:h-[320px]">
                            <img
                                src="images/organisators.jpg"
                                alt="organisators"
                                className="w-full h-full object-cover rounded-[3px]"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganisatorsSection;
